import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {useAuth} from "../../../../../../utils/contexts/auth-context";
import {IProject} from "../../../../../../utils/interfaces/my_projects/IProject";


const useApiUpdateProject = (): UseMutationResult<IProject, CustomAxiosError, {
    id: number;
    data: any
}, unknown> => {
    const queryClient = useQueryClient();
    const {selectedCompany} = useAuth()

    const {put} = useApiCalls()


    async function doUpdate(company_token: string | undefined,
                            pk: number | undefined,
                            data: any): Promise<IProject> {
        try {
            const response = await put(`/api/company/${company_token}/my_projects/projects/${pk}`, data);
            return response.data as IProject;
        } catch (error) {
            throw error;
        }
    }

    return useMutation<IProject, CustomAxiosError, {
        id: number;
        data: any
    }, unknown>({
        mutationFn: async ({id, data}) => {
            return await doUpdate(selectedCompany?.company_token, id, data);
        },

    });
};


export default useApiUpdateProject;